module.exports = __webpack_public_path__ + "img/bottom5.28be16fa.png";